import {
  createError,
  defineNuxtRouteMiddleware,
  useAsyncData,
  useNuxtApp,
  useRuntimeConfig,
} from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { PRODUCT_ROUTES } from '~/scopes/product-core/route-names'

export default defineNuxtRouteMiddleware(async function masterPP(to) {
  const { slug } = to.params
  const $httpFetch = useHttpFetch()

  const nuxtApp = useNuxtApp()

  const { FF_PRODUCT_PAGE_IPHONE_17_EVENT_PAGE = '' } =
    useRuntimeConfig().public
  const { countryCode } = useMarketplace().market

  if (to.params.slug === 'samsung-s26') {
    if (!FF_PRODUCT_PAGE_IPHONE_17_EVENT_PAGE.includes(countryCode)) {
      throw createError({
        statusCode: 404,
        statusMessage: 'Samsung s26 page is not active',
      })
    }

    return
  }

  const { data, error } = await useAsyncData(
    `MasterPP-${slug}`,
    async () => {
      if (
        to.name !== PRODUCT_ROUTES.MASTER_PRODUCT_PAGE &&
        to.name !== PRODUCT_ROUTES.DEV_ONLY_MASTER_PRODUCT_PAGE
      ) {
        return null
      }

      return $httpFetch('/product-page/parent-products/:slug', {
        pathParams: { slug: `${slug}` },
      })
    },
    {
      getCachedData: (key) => nuxtApp.payload.data[key],
    },
  )

  if (error.value || !data.value?.productId) {
    throw createError({
      statusCode: error.value?.statusCode || 404,
      statusMessage: '[PRODUCT] Master PP Product id not found',
      fatal: true,
    })
  }
})
